export const INITIAL_DATA_PARAMS = {
  count: 0,
  next: null,
  previous: null,
  page: 1,
  sizePerPage: 10,
  results: [],
}
